import { connect } from 'react-redux';

import RootLoadingSpinnerComponent from '@app/components/Loading/RootLoadingSpinnerComponent';
import { isFetchingSelector } from '@app/store/template/selectors';

const mapStateToProps = (state) => ({
  isLoading: isFetchingSelector(state),
  isOverlay: true,
});

export default connect(mapStateToProps, null)(RootLoadingSpinnerComponent);
